"use client";

import { useRouter } from "@/i18n/navigation";
import { BackNav } from "@/ui";

export const BackNavClient = () => {
  const router = useRouter();
  return <BackNav onBack={() => router.back()} />;
};
